export const ID = 'id';
export const INTERVIEWER_SIGNATURE_URL = 'interviewerSignatureUrl';
export const INTERVIEWER_SIGNED_AT = 'interviewerSignedAt';